export const contactsData = {
    email: 'mustafahawari64@gmail.com',
    phone: '+9779845887680',
    address: 'Birgunj, Parsa, Nepal',

    sheetAPI: ''
}